/* Destilo — expose the header (navbar) height as --header-height so sections
   can size themselves to "one screen minus the navbar". */
(function () {
  function setHeaderHeight() {
    const el =
      document.querySelector('.header-wrapper') ||
      document.querySelector('header.header') ||
      document.querySelector('.section-header');
    const h = el ? Math.round(el.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setHeaderHeight);
  } else {
    setHeaderHeight();
  }
  window.addEventListener('load', setHeaderHeight);
  window.addEventListener('resize', setHeaderHeight);
})();
